import { useContext } from 'react';
import {SubscriptionsTranslationsContext} from "./SubscriptionsTranslationsContext";

export const useSubscriptionTranslationsContext = () => useContext(SubscriptionsTranslationsContext);